export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: false,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"name":"Português - Brasil","code":"pt-br","iso":"pt-BR","file":"pt-br.js"},{"name":"English","code":"en","iso":"en","file":"en.js"},{"name":"Español - España","code":"es","iso":"es-ES","file":"es.js"},{"name":"Español - España","code":"es-es","iso":"es-ES","file":"es-es.js","hidden":true},{"name":"Español - Colombia","code":"es-co","iso":"es-CO","file":"es-co.js","hidden":true},{"name":"Español - Colombia","code":"co","iso":"es-CO","file":"co.js"},{"name":"Español - México","code":"es-mx","iso":"es-MX","file":"es-mx.js","hidden":true},{"name":"Español - México","code":"mx","iso":"es-MX","file":"mx.js"},{"name":"Español - América Latina","code":"la","iso":"es-419","file":"la.js"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "i18n/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":true,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":".hotmart.com","cookieKey":"hmLangCookie","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://hotmart.com",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"index":{"pt-br":"/hotmartacademy","en":"/digital-learning","es":"/digital-learning","co":"/digital-learning","mx":"/digital-learning","la":"/digital-learning"},"thank-you":{"co":"/digital-learning/gracias","mx":"/digital-learning/gracias","la":"/digital-learning/gracias"}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  fallbackLocale: "en",
  normalizedLocales: [{"name":"Português - Brasil","code":"pt-br","iso":"pt-BR","file":"pt-br.js"},{"name":"English","code":"en","iso":"en","file":"en.js"},{"name":"Español - España","code":"es","iso":"es-ES","file":"es.js"},{"name":"Español - España","code":"es-es","iso":"es-ES","file":"es-es.js","hidden":true},{"name":"Español - Colombia","code":"es-co","iso":"es-CO","file":"es-co.js","hidden":true},{"name":"Español - Colombia","code":"co","iso":"es-CO","file":"co.js"},{"name":"Español - México","code":"es-mx","iso":"es-MX","file":"es-mx.js","hidden":true},{"name":"Español - México","code":"mx","iso":"es-MX","file":"mx.js"},{"name":"Español - América Latina","code":"la","iso":"es-419","file":"la.js"}],
  localeCodes: ["pt-br","en","es","es-es","es-co","co","es-mx","mx","la"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "p",
  3: "t",
  4: "-",
  5: "b",
  6: "r",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "i",
  17: "1",
  18: "8",
  19: "n",
  20: "/",
  21: "p",
  22: "t",
  23: "-",
  24: "b",
  25: "r",
  26: ".",
  27: "j",
  28: "s",
  29: "\"",
  30: ",",
  31: "\"",
  32: "e",
  33: "n",
  34: ".",
  35: "j",
  36: "s",
  37: "\"",
  38: ":",
  39: "\"",
  40: ".",
  41: ".",
  42: "/",
  43: "i",
  44: "1",
  45: "8",
  46: "n",
  47: "/",
  48: "e",
  49: "n",
  50: ".",
  51: "j",
  52: "s",
  53: "\"",
  54: ",",
  55: "\"",
  56: "e",
  57: "s",
  58: ".",
  59: "j",
  60: "s",
  61: "\"",
  62: ":",
  63: "\"",
  64: ".",
  65: ".",
  66: "/",
  67: "i",
  68: "1",
  69: "8",
  70: "n",
  71: "/",
  72: "e",
  73: "s",
  74: ".",
  75: "j",
  76: "s",
  77: "\"",
  78: ",",
  79: "\"",
  80: "e",
  81: "s",
  82: "-",
  83: "e",
  84: "s",
  85: ".",
  86: "j",
  87: "s",
  88: "\"",
  89: ":",
  90: "\"",
  91: ".",
  92: ".",
  93: "/",
  94: "i",
  95: "1",
  96: "8",
  97: "n",
  98: "/",
  99: "e",
  100: "s",
  101: "-",
  102: "e",
  103: "s",
  104: ".",
  105: "j",
  106: "s",
  107: "\"",
  108: ",",
  109: "\"",
  110: "e",
  111: "s",
  112: "-",
  113: "c",
  114: "o",
  115: ".",
  116: "j",
  117: "s",
  118: "\"",
  119: ":",
  120: "\"",
  121: ".",
  122: ".",
  123: "/",
  124: "i",
  125: "1",
  126: "8",
  127: "n",
  128: "/",
  129: "e",
  130: "s",
  131: "-",
  132: "c",
  133: "o",
  134: ".",
  135: "j",
  136: "s",
  137: "\"",
  138: ",",
  139: "\"",
  140: "c",
  141: "o",
  142: ".",
  143: "j",
  144: "s",
  145: "\"",
  146: ":",
  147: "\"",
  148: ".",
  149: ".",
  150: "/",
  151: "i",
  152: "1",
  153: "8",
  154: "n",
  155: "/",
  156: "c",
  157: "o",
  158: ".",
  159: "j",
  160: "s",
  161: "\"",
  162: ",",
  163: "\"",
  164: "e",
  165: "s",
  166: "-",
  167: "m",
  168: "x",
  169: ".",
  170: "j",
  171: "s",
  172: "\"",
  173: ":",
  174: "\"",
  175: ".",
  176: ".",
  177: "/",
  178: "i",
  179: "1",
  180: "8",
  181: "n",
  182: "/",
  183: "e",
  184: "s",
  185: "-",
  186: "m",
  187: "x",
  188: ".",
  189: "j",
  190: "s",
  191: "\"",
  192: ",",
  193: "\"",
  194: "m",
  195: "x",
  196: ".",
  197: "j",
  198: "s",
  199: "\"",
  200: ":",
  201: "\"",
  202: ".",
  203: ".",
  204: "/",
  205: "i",
  206: "1",
  207: "8",
  208: "n",
  209: "/",
  210: "m",
  211: "x",
  212: ".",
  213: "j",
  214: "s",
  215: "\"",
  216: ",",
  217: "\"",
  218: "l",
  219: "a",
  220: ".",
  221: "j",
  222: "s",
  223: "\"",
  224: ":",
  225: "\"",
  226: ".",
  227: ".",
  228: "/",
  229: "i",
  230: "1",
  231: "8",
  232: "n",
  233: "/",
  234: "l",
  235: "a",
  236: ".",
  237: "j",
  238: "s",
  239: "\"",
  240: "}",
}

export const localeMessages = {
  'pt-br.js': () => import('../../i18n/pt-br.js' /* webpackChunkName: "lang-pt-br.js" */),
  'en.js': () => import('../../i18n/en.js' /* webpackChunkName: "lang-en.js" */),
  'es.js': () => import('../../i18n/es.js' /* webpackChunkName: "lang-es.js" */),
  'es-es.js': () => import('../../i18n/es-es.js' /* webpackChunkName: "lang-es-es.js" */),
  'es-co.js': () => import('../../i18n/es-co.js' /* webpackChunkName: "lang-es-co.js" */),
  'co.js': () => import('../../i18n/co.js' /* webpackChunkName: "lang-co.js" */),
  'es-mx.js': () => import('../../i18n/es-mx.js' /* webpackChunkName: "lang-es-mx.js" */),
  'mx.js': () => import('../../i18n/mx.js' /* webpackChunkName: "lang-mx.js" */),
  'la.js': () => import('../../i18n/la.js' /* webpackChunkName: "lang-la.js" */),
}
